var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","dark":"","loading":_vm.loading,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.analizar}},[_vm._v(" CUOTAS NO PAGADAS "),_c('v-icon',{attrs:{"right":"","color":"white"}},[_vm._v("fas fa-search")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }